/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var DefaultFormatType;
(function (DefaultFormatType) {
    DefaultFormatType["Custom"] = "CUSTOM";
    DefaultFormatType["Number"] = "NUMBER";
    DefaultFormatType["Currency"] = "CURRENCY";
    DefaultFormatType["Percentage"] = "PERCENTAGE";
    DefaultFormatType["Date"] = "DATE";
})(DefaultFormatType || (DefaultFormatType = {}));
export function DefaultFormatTypeFromJSON(json) {
    return DefaultFormatTypeFromJSONTyped(json, false);
}
export function DefaultFormatTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function DefaultFormatTypeToJSON(value) {
    return value;
}
